import React from 'react';
import PropTypes from 'prop-types';
import { GuideSection, GuideSectionTitle, SlidePrompt, ScrollableContainer } from './SizeGuide.css';
import { Mobile } from '../MediaQuery';

const renderHeaderAndPrompt = (label, name) => {
  return (
    <>
      <GuideSectionTitle data-cy={`size-${name}-active`}>{label}</GuideSectionTitle>
      <SlidePrompt>{'Slide to scroll >'}</SlidePrompt>
    </>
  );
};

class SelectableTable extends React.Component {
  render() {
    const { name, label, children, render } = this.props;

    return render ? (
      <GuideSection id={name}>
        <Mobile>{label && renderHeaderAndPrompt(label, name)}</Mobile>
        <ScrollableContainer>{children}</ScrollableContainer>
      </GuideSection>
    ) : null;
  }
}

SelectableTable.propTypes = {
  render: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
};

export default SelectableTable;
